import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.mention.UserMention')
export class UserMention extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'clazz')
    clazz?: string;

    @JsonProperty(User, 'user')
    user?: User;

    @JsonProperty(Number, 'entityId')
    entityId?: number;
}